import PropTypes from 'prop-types';
import {
  EmailShareButton,
  FacebookShareButton,
  FacebookIcon,
  EmailIcon,
  WhatsappShareButton,
  WhatsappIcon,
} from 'react-share';

import { analytics, getPageShareDetail } from '@/utils/analytics';

// @TODO: update the design after design done
function ShareAll({ url, size, title }) {
  const handleShare = (channel, e) => {
    analytics({
      window,
      document,
      detail: getPageShareDetail(e, { channel }),
    });
  };

  return (
    <div className="aaco-share flex flex-wrap m-10 gap-6 justify-center">
      <FacebookShareButton
        url={url}
        onClick={(e) => handleShare('Facebook', e)}
      >
        <FacebookIcon size={size} borderRadius={50} />
      </FacebookShareButton>
      <WhatsappShareButton
        url={url}
        title={title}
        onClick={(e) => handleShare('Whatsapp', e)}
      >
        <WhatsappIcon size={size} borderRadius={50} />
      </WhatsappShareButton>
      <EmailShareButton
        openShareDialogOnClick
        title={title}
        url={url}
        onClick={(e) => handleShare('Email', e)}
      >
        <EmailIcon size={size} borderRadius={50} />
      </EmailShareButton>
    </div>
  );
}

ShareAll.propTypes = {
  children: PropTypes.node,
  socialTypes: PropTypes.array,
  title: PropTypes.string,
  url: PropTypes.string,
};

ShareAll.defaultProps = {
  title: '',
};

export default ShareAll;
